



































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import FileSelector from '@/components/common/FileSelector.vue';
import { Storage } from 'aws-amplify';
import ImagePicker from '@/components/common/ImagePicker.vue';
// import DrupalImageTest from '@/components/common/DrupalImageTest.vue';
import AudioPicker from '@/components/common/AudioPicker.vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import { ValueTypeDefinition } from '@/api/model/FactorResource';
import ChoiceFactorInputDateTime from '@/components/choice-input/ChoiceFactorInputDateTime.vue';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { getModule } from 'vuex-module-decorators';
import Choices from '@/store/modules/Choices';

@Component({
    components: {
        ChoiceFactorInputDateTime,
        ImagePicker,
        AudioPicker,
        FileSelector,
        DescriptionEditor,
        // DrupalImageTest,
    },
})
export default class ChoiceFactorInput extends Vue {
    @Prop()
    choiceId!: string;

    @Prop()
    form!: any;

    @Prop()
    dialog!: boolean;

    @Prop()
    description!: string;

    @Prop()
    dataField!: string;

    @Prop()
    listIndex!: number;

    @Prop()
    scoringDefinition!: any;

    @Prop({ default: 300, type: Number })
    columnSize!: number;

    @Prop()
    valueTypeDefinition!: ValueTypeDefinition;

    @Prop({ default: false, type: Boolean })
    outlined!: boolean;

    @Prop({ default: false, type: Boolean })
    clearable!: boolean;

    @Prop({ default: false, type: Boolean })
    choiceCard!: boolean;

    @Prop({ default: false, type: Boolean })
    embed!: boolean;
    
    @Prop({ default: false, type: Boolean })
    choiceSubmitter!: boolean;

    @Prop({ default: '', type: String })
    maxWidth!: string;

    @Prop({ default: false, type: Boolean })
    disableInput!: boolean;

    private keyIncrement: number = 0;

    private datepickerMenu = false;

    mounted() {
        Storage.configure({ level: 'public' });
    }

    @Watch('choiceId')
    onChoiceIdChange() {
        this.keyIncrement++;
    }

    get valueType() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueType;
    }

    get valueSubType() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueSubType;
    }

    get valuePrefix() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valuePrefix;
    }

    get valueSuffix() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueSuffix;
    }

    get valueFormat() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.format;
    }

    get categoricalValues() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.categoricalValues;
    }

    get dateFormValue() {
        if (this.valueType === 'DATE_TIME') {
            if (this.formValue) {
                return moment(this.formValue).format(this.valueFormat);
            }
        }
    }

    set dateFormValue(val:any){
        this.formValue = val;
    }
    get formValue() {
        if (this.listIndex == null) {
            return this.form[this.dataField];
        }
        return this.form[this.dataField][this.listIndex];
    }

    set formValue(value: any) {
        if (
            this.listIndex === null ||
            this.listIndex === undefined ||
            !this.form.hasOwnProperty(this.dataField)
        ) {
            Vue.set(this.form, this.dataField, value);
        } else {
            this.form[this.dataField].splice(this.listIndex, 1, value);
        }
    }

    get keyPrefix() {
        let prefix = '';
        if (this.choiceId) {
            prefix = prefix + this.choiceId + '/';
        } else {
            prefix = uuidv4() + '/';
        }
        if (this.listIndex == null) {
            return prefix + this.dataField;
        }
        return prefix + this.dataField + '-' + this.listIndex;
    }

    get editPermissions() {
        if (!this.disableInput) {
            return getModule(Choices).checkChoiceEditPermissions;
        } else {
            return false;
        }
    }

    private numOfRows(dataField: any) {
        if (dataField && dataField.length) {
            return Math.ceil(dataField.length / (this.columnSize / 5));
        }
        return 1;
    }

    private dateSelected() {}

    private timeSelected() {}

    private selectAll(e: Event) {
        if (e.target) {
            (e.target as HTMLInputElement).select();
        }
    }
}
